// 添加评价
const evaluationPage = () => import('@/pages/learningGuidePage/evaluation/evaluationPage.vue');
const learningGuide = () => import('@/pages/learningGuidePage/learningGuide.vue');
const studyReport = () => import('@/pages/learningGuidePage/evaluation/studyReport.vue');

export default [
  {
    path: '/evaluation',
    name: 'evaluation',
    component: evaluationPage,
    meta: {
      title: '评价',
      requireAuth: true,
    },
  },
  {
    path: '/learningGuide',
    name: 'learningGuide',
    component: learningGuide,
    meta: {
      title: '导学页',
      requireAuth: true,
    },
  },
  {
    path: '/studyReport',
    name: 'studyReport',
    component: studyReport,
    meta: {
      title: '学习报告',
      requireAuth: true,
    },
  },
];
